import { gql } from '__generated__';

export default gql(`
  mutation EditMessage($input: EditMessageInput!) {
    editMessage(input: $input) {
      ...MessageAttributes
      ...MessageRecipientsAttributes
    }
  }
`);
